import React from "react";
import { Column, ColumnId } from ".";
import ExecutorArrivalDateCellContent from "../components/ExecutorArrivalDateCellContent";
import base from "./base";

function executorArrivalDate({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutorArrivalDate,
		(item) => <ExecutorArrivalDateCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executorArrivalDate;
